"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-nocheck

var instanceOf_1 = require("./instanceOf");
/**
 * @param element
 */


function getDocumentElement(element) {
  // $FlowFixMe: assume body is always available
  return (instanceOf_1.isElement(element) ? element.ownerDocument : element.document).documentElement;
}

exports["default"] = getDocumentElement;